import React from "react";
import FeatureCard from "./FeatureCard";

const FeatureGrid = () => {
  return (
    <div className="card-grid">
      <FeatureCard
        iconColor="#FF6A00"
        title="Built to Last"
        description="We build with intention — creating products designed for real problems, not fleeting trends."
      />
      <FeatureCard
        iconColor="#007BFF"
        title="Simplicity as Strength"
        description="We believe the best solutions are elegant, intuitive, and built to endure."
      />
      <FeatureCard
        iconColor="#FFC107"
        title="Iterate Fearlessly"
        description="We're not afraid to rebuild, rethink, or start over if it means building something better."
      />
    </div>
  );
};

export default FeatureGrid;
